import { render, staticRenderFns } from "./CurrentInvoiceTab.vue?vue&type=template&id=f3b56388&scoped=true"
import script from "./CurrentInvoiceTab.vue?vue&type=script&lang=js"
export * from "./CurrentInvoiceTab.vue?vue&type=script&lang=js"
import style0 from "./CurrentInvoiceTab.vue?vue&type=style&index=0&id=f3b56388&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b56388",
  null
  
)

export default component.exports